import React from 'react'
import UploadActions from '../../actions/upload-actions'
import createReactClass from 'create-react-class'


var UploadErrorMessage = createReactClass({

    removeErrorMessage: function () {
        UploadActions.removeUploadError(this.props.messageId);
    },
    render: function () {
        return (<div className="ope_upload__error__message">{this.props.message} <span
            className="ope_upload__error__message__remove" onClick={this.removeErrorMessage}>x</span></div>);
    }
});

export default UploadErrorMessage;
